import { createApp, reactive } from 'vue';
import VueLazyload from 'vue-lazyload';
import i18next from 'i18next';
import I18NextVue from 'i18next-vue';

import PublicProfileReviewCollection from '../pages/public_profile/ReviewCollection.vue';
import ProfileReviewItem from '../components/ProfileReviewItem.vue';
import ReviewSearchForm from '../components/ReviewSearchForm.vue';
import SearchInput from '../components/SearchInput.vue';

class PublicProfileReviewComponent {
  constructor({ container, scope }) {
    this.app = null;
    this.container = container;
    this.scope = scope;
  }

  init() {
    this.app = createApp(PublicProfileReviewCollection, {
      scope: this.scope
    });
    this.app.use(I18NextVue, { i18next });
    this.app.use(VueLazyload, {
      preLoad: 2.6 // default 1.3
    });

    this.app.component('profile-review-item', ProfileReviewItem);
    this.app.component('review-search-form', ReviewSearchForm);
    this.app.component('search-input', SearchInput);
    // Mount the Vue app to the specified container
    this.app.mount(this.container);
  }
}

export default PublicProfileReviewComponent;